module.exports = __webpack_public_path__ + "img/ab_right1.a0748921.png";